// extracted by mini-css-extract-plugin
module.exports = {"contents":"_8lEj30RIeRv6vqDZTOG4Z"};